import axios from 'axios';
import _ from 'lodash';

import {typesSojourn} from '../svtypes/sojournTypes'

import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export function sojDetailsAndImagesSV(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(etSojournBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourDetailViewCanQuery`
        //bodyold for svacanary
       
          /*
           const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourDetailView`
        
         const bodyWorkingLatestSV = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000068@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
           const bodyOld = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
          if (nameQParam && nameQParam !=''){
              body["query"]["match"]["SPACEKEY.keyword"]= nameQParam
          }
          "10000068@4@F@10@10@20251124@7@Y@SVR"
          let bodyOld = {
            "query": nameQParam,
            "name":"SPACEKEY.keyword",
            "operator":"and",
            "estype":"string"
        }
          */
          
        let body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000078@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
          
          if (nameQParam && nameQParam !=''){
            body["query"]["match"]["SPACEKEY.keyword"]= nameQParam
          }
        //const urlSojImages = 'http://localhost:8080/essearch/images'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`

        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        sod =  _.clone(ob)

                        

                        comData.my_data.push(sod)
                    });
                    if( r2.data ){
                        const im_ob = r2.data
                        comData.my_images = im_ob
                    }
                   
                    dispatch(getSojournMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getSojournSuccess(comData))
                }
                  
                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getSojournError(e))
        )
    }
    
}

export function getSojournDetails(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(etSojournBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourDetailView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data.push(sod)
                    });

                   
                    dispatch(getSojournSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getSojournSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getSojournError(e))
        )
    }
}




export const getSojournSuccess = (data) => dispatch => {
    dispatch({
        type: typesSojourn.GET_SOJOURN_SUCCESS,
        payload: data
    })
}
export const getSojournMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesSojourn.GET_SOJOURN_SUCCESS,
        payload: data
    })
}

export const etSojournBegin = () => dispatch => {
    dispatch({
        type:typesSojourn.GET_SOJOURN_BEGIN
        
    })
}

export const getSojournError = (e) =>dispatch => {
    dispatch({
        type:typesSojourn.GET_SOJOURN_ERROR,
        error:e
    })
}

/*sjjul start

export function sojAndImagesSojournPaginate1HotelById(sojPostRqFromPage, sv_esquery_data){
    console.log('SJ**JUN12Y2025 esqueryText*********', sv_esquery_data)
                       
    return dispatch => {
        dispatch(etSojournBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojourndol`
    //getResAsyncWorkingSvCanQueryTermsSojDyna
    ///sojournpoint/svsojournCanQueryFinalDyna
    // latestjul9y25 const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
    //mock
    const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate_detail_mock` 
    //mock workin may12
       //http://localhost:8086/shpoint/sojourndol
       
         let sojPostRq= {
            "svfields": [
                "images",
                "sojourn_name",
                "address",
                "code",
                "sojournGeocode",
                "categoryCode",
                "categoryGroupCode",
                "accommodationTypeCode",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "countryCode",
                "ranking",
                "web",
                "terminals",
                "interestPoints",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-08",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-09",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "accommodationTypeCode": "H"
            },
            "useCity": false,
            "dst": "SEATTLE",
            "sv_room_data": {
                "id": "-4",
                "fname": "Ror",
                "members": [
                    {
                        "rooms": 1,
                        "adultType": "t2",
                        "childType": "m0"
                    }
                ]
            },
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [],
            "destinationCode": "SEATTLE",
            "esqueryRooms": "r1",
            "pagenumber": 1,
            "my_scr_id": ""
        }
          let sojPostRqDyna = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       console.log('sv****8')
       
        sojPostRq["pagenumber"] = 1
        sojPostRq["my_scr_id"] = ""
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                   
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                   
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        //svjun9
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let assets = a_price['assets']
                        const aroom = assets[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        a_rec['product_cost_amount'] = arate['net']

                        //svjun9 end

                        let HB_REVIEWS_HW = [
                            {
                                "rate": 4,
                                "reviewCount": 15,
                                "type": "HOTELBEDS"
                            }
                        ]
                        let reviews_ob = a_price["reviews"] ?a_price["reviews"] : HB_REVIEWS_HW
                        
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                      
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                    comData.my_scr_id = rFob.my_scr_id
                    
                   
                    dispatch(getOhSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2025-10-24",
                        ENDDATE: "2025-11-27" , 
                        time_zone: "+01:00"
                
                      }
                      if(sv_esquery_data){
                        comData.sv_esquery_data = sv_esquery_data
                      }
                     
                    dispatch(getOneHotelAvailSearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getSojournError(e))}
           
        )
    }
}
*/
export const getOhSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_SOJ_PROD_AVL_HOTEL_SUCCESS',
        payload: data
    })
}


export const getOneHotelAvailSearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "FlyServer Error",
        "message": "No Sojourns Found.Please refinse search and try again",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:"GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR",
        error:eob
    })
}

/*sjjul2 end*/
/*
export const getOhSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_SOJ_PROD_AVL_HOTEL_SUCCESS',
        payload: data
    })
}


export const getOneHotelAvailSearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "FlyServer Error",
        "message": "No Sojourns Found.Please refinse search and try again",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:"GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR",
        error:eob
    })
}
*/
/*sjjul2 end*/
/*sjjul12 */


export function sojAndImagesSojournPaginate1HotelById(sojPostRqFromPage, sv_esquery_data){
    console.log('SJ**JUN12Y2025 esqueryText****codeId, sv_esquery_data*****',sojPostRqFromPage, sv_esquery_data)
                       
    return dispatch => {
        dispatch(etSojournBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojournsttr`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/sojourndol`
    //getResAsyncWorkingSvCanQueryTermsSojDyna
    ///sojournpoint/svsojournCanQueryFinalDyna
    // latestjul9y25 const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate`
    //mock
  //  const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinalDynaPaginate_detail_mock` 
  const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/sjoneHotelQueryAndAvail` 
   
    //mock workin may12
       //http://localhost:8086/shpoint/sojourndol
       /*
         const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsojournCanQueryFinal`
      
      

        */
         let sojPostRq= {
            "svfields": [
                "images",
                "sojourn_name",
                "address",
                "code",
                "sojournGeocode",
                "categoryCode",
                "categoryGroupCode",
                "accommodationTypeCode",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "countryCode",
                "ranking",
                "web",
                "terminals",
                "interestPoints",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST":sv_esquery_data.STARTDATE ? sv_esquery_data.STARTDATE :"2025-08-08",
                "ENDDATE_ITN_TZAWARE_EST":sv_esquery_data.ENDDATE ? sv_esquery_data.ENDDATE : "2025-08-09",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "accommodationTypeCode": "H"
            },
            "useCity": false,
            "dst": sv_esquery_data.my_esqueryText ? sv_esquery_data.my_esqueryText :"SEATTLE",
            "sv_room_data": {
                "id": "-4",
                "fname": "Ror",
                "members": [
                    {
                        "rooms": 1,
                        "adultType": "t2",
                        "childType": "m0"
                    }
                ]
            },
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [],
            "destinationCode":sv_esquery_data.my_esqueryText ? sv_esquery_data.my_esqueryText : "",
            "esqueryRooms": "r1",
            "pagenumber": 1,
            "my_scr_id": ""
        }
          let sojPostRqDyna = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
        const HBD_URL = 'http://photos.hotelbeds.com/giata/'
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       console.log('sv****8')
       /*
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        */
        /*
        "pagenumber":1,
	"my_scr_id":""
        */
        sojPostRq["pagenumber"] = 1
        sojPostRq["my_scr_id"] = ""
///sojournpoint/fgTreeForSojourn
        //let fgurl = 'http://localhost:8086/sojournpoint/fgTreeForSojourn'
        const fgurl = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/fgTreeForSojourn`
       
        let fgrq = {
            "docId":["92335"],
            "hsetname":"hotelid"
        }
        let codeOrHotelIdStr = sojPostRqFromPage.paramQSpaceId
        let codeOrHotelIdInt = parseInt(codeOrHotelIdStr)
        fgrq.docId = []
        fgrq.docId.push('' + codeOrHotelIdStr )
        sojPostRq.codeKeys = []
        //sojPost is Int codeKeys
        sojPostRq.codeKeys.push( codeOrHotelIdInt )

        //svparams
        
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.post(fgurl, fgrq,{headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2, r3)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.length>0){
                    prices_idx = p.data
                }
                let aird = null
                let airc = null
                prices_idx.forEach(p_rec => {
                    let myh = p_rec['hotel']
                    //change this code as SPACEKEY is number
                    /*
                        let mys = p_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                         p_rec['SPACEKEY'] = ckey
                        p_rec['ABODE_SPACE_ID'] = myhead
                        p_rec['SOJOURN_NAME']= myh['sojourn_name']
                        if(p_rec['SPACE_KEY'] ){
                            p_rec['SPACE_KEY'] = ckey
                        }
                    */
                       
                        p_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        p_rec['web'] = myh['web'] ?myh['web'] : "http://svrenaissance.org/svceo"

                        if(p_rec['terminals'] &&  p_rec['terminals'][0]){
                            let ta =  p_rec['terminals'][0]
                            aird = ta["distance"]
                            airc = ta["terminalCode"]
                            p_rec['airportDistance'] =  `${aird} miles from  ${airc} airport`
                        }
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.length>0){
                   
                    const ar = r.data
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if(r3.data ){
                        comData.fgtree = r3.data
                    }
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    //get path and concat them wil base url
                  
                    ar.forEach(a_rec => {
                        let myh = a_rec['hotel']
                        /*
                        let mys = a_rec['SPACEKEY']
                        let p =mys.indexOf('@')
                        let mytail = mys.substr(p, mys.length) 
                        
                        let myhead = myh['code']
                        let ckey =myhead + mytail
                        a_rec['SPACEKEY'] = ckey
                        if(a_rec['SPACE_KEY'] ){
                            a_rec['SPACE_KEY'] = ckey
                            a_rec['SOJOURNCODE'] = ckey
                            a_rec['SPACE_INV_ID']= ckey
                            a_rec['ABODE_SPACE_ID'] = ckey
                            a_rec['ABODESPACEID'] = ckey
                            
                        }
                        */
                        a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"

                        a_rec['SOJOURN_NAME']= myh['sojourn_name']
                        a_rec["COUNTRY_NAME"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["ADDRESS_LINE1"] = address_s
                        item = {}
                        let hbd_images  = a_rec.hotel.images
                        let imgs = []
                        //hbd_images  = hbd_images? hbd_images : r2.data.images
                        if(hbd_images && (hbd_images.length > 0) ){
                            hbd_images.forEach(im =>{
                                let sim =  HBD_URL +  im.path 
                                imgs.push(sim)
                               })
                        }else{
                            imgs = r2.data.images
                        }
                       
                        if(imgs.length > 0){
                            comData.my_images = imgs
                        }

                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        //svjun9
                        let k_sv = ob['spacekey']
                        a_price = prices_map[k_sv]
                        let assets = a_price['assets']
                        const aroom = assets[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        a_rec['product_cost_amount'] = arate['net']

                        //svjun9 end

                        let HB_REVIEWS_HW = [
                            {
                                "rate": 4,
                                "reviewCount": 15,
                                "type": "HOTELBEDS"
                            }
                        ]
                        let reviews_ob = a_price["reviews"] ?a_price["reviews"] : HB_REVIEWS_HW
                        
                        let review_ob = reviews_ob[0]
                       //num_reviews
                        let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                        let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                        ob['num_reviews'] = reviewCount
                        //let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    ob['imgs'] = imgs
                    
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                    comData.my_scr_id = rFob.my_scr_id
                    /*
                    let svr_soj_detail_images_ob_tp = {
                        "images":[],
                        "gallery":[ ],
                        "arcade":[],
                        "face":[]
                    
                    }
                    comData.svr_soj_detail_images_ob = svr_soj_detail_images_ob_tp
                   */
                   
                    dispatch(getOhSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2025-10-24",
                        ENDDATE: "2025-11-27" , 
                        time_zone: "+01:00"
                
                      }
                      if(sv_esquery_data){
                        comData.sv_esquery_data = sv_esquery_data
                      }
                      /*sjjun19 start
                       dispatch(getEsSearchSuccess(comData))

                      */
                    dispatch(getOneHotelAvailSearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getSojournError(e))}
           
        )
    }
}

